/* @flow */
export const THRESHOLD_JE_LOAD = 40;

export const INCLUDES_MAP = {
  index_list: { list: '_options' },
};
